import styled from 'styled-components';
import UserSellTractorImageMain from '../../../../../assets/images/userSellTractor/user_sell_tractor_image_main.png';

export const Section1 = () => {
  return (
    <Container>
      <Title>{'내 트랙터를 무료로 간편하게\n판매하고 싶다면?'}</Title>

      <Description>
        {'회원간 거래할 수 있는 '}
        <DescriptionBlue>{'직거래 매물'}</DescriptionBlue>
        {'을 통하여\n'}
        <DescriptionBlue>{'수수료 없이 판매'}</DescriptionBlue>
        {'할 수 있습니다.\n'}
        {'플루바 마켓에서 지금 바로 판매를 시작해보세요!'}
      </Description>

      <MainImageWrappper>
        <MainImage src={UserSellTractorImageMain} alt={'sell-tractor-main'} />
        <MainImageBlurredPart />
      </MainImageWrappper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  padding: 32px;
  gap: var(--radius-large, 16px);
`;

const Title = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const Description = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const DescriptionBlue = styled.span`
  color: var(--Light-Scheme-Color-primary-blue, #445eff);

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
`;

const MainImageWrappper = styled.div`
  width: 100%;
  height: 209px;
  max-height: 209px;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  padding-top: 32px;

  gap: 10px;

  overflow: hidden;

  position: relative;
`;

const MainImage = styled.img`
  width: 293.209px;
  height: 304.365px;

  border-radius: var(--radius-medium, 8px);
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
`;

const MainImageBlurredPart = styled.div`
  width: 100%;
  height: 78px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: var(--radius-large, 16px);
  gap: var(--radius-small, 4px);

  border-radius: var(--radius-none, 0px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);

  position: absolute;
  bottom: 0;
  left: 50%;

  transform: translateX(-50%);
`;
